import axios from "axios";
import { Common } from "../lib/Common";

export const UrlTools = {
    _slash: "/",

    trimTrailingSlash(url) {
        return url?.endsWith(this._slash) ? url.slice(0, -1) : url
    },

    join(url, path) {
        url = this.trimTrailingSlash(url);

        let separator = path.startsWith(this._slash) ? "" : this._slash;

        return url + separator + path;
    }
}

export class RequestHelper {

    baseUrl = "";

    config = {
        "method": "GET",
        "url": "",
        "params": {},
        "headers": {},
        "data": null,
        "responseType": "json",
        "cancelToken": null
    };

    callback = null;

    usePromise = false;

    errorResp = null;

    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }

    withPath(path) {
        if (this.baseUrl === null) {
            throw new Error("Base url not defined");
        }

        let url = UrlTools.join(this.baseUrl, path);

        return this.withUrl(url);
    }

    withData(data) {
        this.config.data = data;
        return this;
    }

    withMethod(method) {
        this.config.method = method;
        return this;
    }

    withUrl(url) {
        this.config.url = url;
        return this;
    }

    withParams(params) {
        this.config.params = params;
        return this;
    }

    withResponseType(responseType) {
        this.config.responseType = responseType;
        return this;
    }

    withCancellationToken(cancelToken) {
        this.config.cancelToken = cancelToken;
        return this;
    }

    withHeader(key, value) {
        if (this.config.headers == null) {
            this.config.headers = {};
        }

        this.config.headers[key] = value;
        return this;
    }

    withHeaders(headers) {
        this.config.headers = headers;
        return this;
    }

    usingCallback(callback) {
        this.callback = callback;
        return this;
    }

    usingErrorHandling(errorResp) {
        this.errorResp = errorResp;
        return this;
    }

    usingPromise() {
        this.usePromise = true;
        return this;
    }

    //TODO: #execute when private methods are working
    _execute(excludeTrackingHeaders = false) {
        if (!excludeTrackingHeaders) {
            if (this.config.headers == null) {
                this.config.headers = {};
            }
            this.config.headers["x-correlation-id"] = Common.xCorrelationId();
            this.config.headers["x-request-id"] = Common.xRequestId();
        }

        if (this.usePromise) {
            return axios(this.config);
        }

        const handleError = (method, error) => {
            if (axios.isCancel(error)) {
                Common.log(method + " function request has been manually cancelled.");
            } else if (error.response) {
                // Request made and server responded
                Common.log(error.response);
            } else if (error.request) {
                // The request was made but no response was received
                Common.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                Common.log("Error", error);
            }

            if (this.errorResp === undefined || this.errorResp == null) {
                return;
            }

            if (error.response) {
                this.errorResp(error.response);
            } else if (error.request) {
                this.errorResp("Unable to connect. Network error");
            }
        }

        axios(this.config).then((response) => {
            if (this.callback) {
                this.callback(response);
            }
        }).catch((error) => {
            handleError(this.config.method, error);
        });
    }

    get(excludeTrackingHeaders = false) {
        return this.withMethod("GET")._execute(excludeTrackingHeaders);
    }

    formPost(data, excludeTrackingHeaders = false) {
        return this
            .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
            .post(data, excludeTrackingHeaders);
    }

    post(data = null, excludeTrackingHeaders = false) {
        if (data != null) {
            this.withData(data);
        }

        return this.withMethod("POST")._execute(excludeTrackingHeaders);
    }

    put(data = null, excludeTrackingHeaders = false) {
        if (data != null) {
            this.withData(data);
        }
        return this.withMethod("PUT")._execute(excludeTrackingHeaders);
    }

    delete(excludeTrackingHeaders = false) {
        return this.withMethod("DELETE")._execute(excludeTrackingHeaders);
    }
}

export class SelfServiceApiHelper extends RequestHelper {
}

export class AkamaiApiHelper extends RequestHelper {
}

export default { UrlTools, RequestHelper }